import { usePersistState } from '~/composables/usePersistState'
import type { Operator } from '~/entities/operator'

export const useCurrentOperator = () => {
  const currentOperator = usePersistState<Operator | null>('currentOperator', null)
  return {
    currentOperator,
  }
}
